import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus, setLoader } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import { AlertBar, AlertConfirm } from '../../Modals/AlertBar';
import DateTimeRange from '../UserControl/DateTimeRange/DateTimeRange';
import moment from 'moment';
import TrackingCradList from '../../components/Monitor/TrackingCradList/TrackingCradList';
import TextBoxMultiCarFilter from '../../components/UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import { TimePicker } from 'antd';
import $ from 'jquery';
import { Alert } from '../../Modals/AlertBar';
import ReactToExcel from 'react-html-table-to-excel';
import ModalReportSummaryByGroup from '../Report/ModalReportSummaryByGroup';
import MapAlertSummaryReport from '../../components/Report/MapAlertSummaryReport';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
const Canvas2Image = window.Canvas2Image;


let startHistoryDate = null;
let endHistoryDate = null;
let tagsDevice = [];
class ReportPoiInOut extends Component {
    constructor(props) {
        super(props);
        this.state = {

            isClickLoadReport: '',
            reportType: '',
            selectedReportType: '',
            deviceList: [],
            selectHistoryDateRange: {
                startDate: this.getCurrentDate(new Date()),
                endDate: this.getCurrentDate(new Date()),
                startTimeHistory: "00:00",
                endTimeHistory: "23:50"
            },
            poiList: [],
            selectedPOI: '',
            selectedDevice: '',
            selectedTime: 10,
            poiInOutList: [],
            selectedDeviceName: '',
            isFullScreen: false,
            isMobile: false
        }
    }

    componentWillMount() {
        this.setState({ isMobile: window.innerWidth < 400 });
    }

    componentDidMount() {
        this.getActiveDeviceUserRelated();
        this.getPOIList();
        // this.getDeviceGroupList();
    }

    componentWillUnmount() {
        this.setState({ isDownLoadPdf: false });
    }

    setMultiCar(tags) {
        tagsDevice = tags;
        console.log("tag", tagsDevice);
    }

    setRangeDate(sDate, eDate) {
        let startDate = sDate;
        let endDate = eDate;
        if (sDate && eDate && sDate !== null && eDate !== null) {
            startDate = sDate.toObject();
            endDate = eDate.toObject();
            this.setState({
                startDate: moment(startDate).format('DD-MM-YYYY'),
                endDate: moment(endDate).format('DD-MM-YYYY')
            })
        }
    }

    handleClick = (e) => {
        const { isClickLoadReport } = this.state;
        if (isClickLoadReport === 'show') {
            this.setState({ isClickLoadReport: '' });
        } else {
            this.setState({ isClickLoadReport: 'show' });
        }
    }

    getReport() {
        let obj = this.state.poiInOutList;
        let date = `ระหว่างวันที่ ${this.getCurrentDate(startHistoryDate) + "," + this.state.selectHistoryDateRange.startTimeHistory} ถึง ${this.getCurrentDate(endHistoryDate) + "," + this.state.selectHistoryDateRange.endTimeHistory}`;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/report/exportPdf/08`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token

            },
            body: JSON.stringify({
                "title": date,
                "result_data": obj
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data)
                document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`;
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    btnSearchHistoryClick = (e) => {

        if (e === undefined) {
            return;
        }
        console.log("btnSearchHistoryClick", this.getCurrentDate(startHistoryDate), this.state.selectHistoryDateRange.startTimeHistory, this.state.selectHistoryDateRange.endTimeHistory, tagsDevice);
        if (startHistoryDate == null || endHistoryDate == null || this.state.selectHistoryDateRange.startTimeHistory == "" || this.state.selectHistoryDateRange.endTimeHistory == "")
            Alert("กรุณาใส่ข้อมูล", "วัน เวลา ที่ต้องการดูย้อนหลัง");
        else {
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "/" + mm + "/" + yyyy;
            dd = this.getCurrentDate(endHistoryDate).split("-")[0];
            mm = this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "/" + mm + "/" + yyyy;


            this.onPageSizeChange(stime, start, etime, end, tagsDevice, this.state.currentPage, this.state.currentPageSize);
            // this.getReportSummaryByDevice(stime,start,etime,end,tagsDevice);
            // this.mapTrackingPoi.current.setMapTrackingHistory(stime,start,etime,end,tagsHistory);
            console.log(stime, start, etime, end, tagsDevice)
        }

    }
    getCurrentDate(today) {
        //let today = new Date();
        if (today == null)
            return null;
        let dd = !today.date ? today.getDate() : today.date;
        let mm = today.months == undefined ? today.getMonth() + 1 : today.months + 1; //January is 0! today
        let yyyy = !today.years ? today.getFullYear() : today.years;
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    handleStartTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    handleEndTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    setRangeDate(sDate, eDate) {
        startHistoryDate = sDate;
        endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            startHistoryDate = sDate.toObject();
            endHistoryDate = eDate.toObject();
        }
        console.log("setRangeDate", startHistoryDate, endHistoryDate);
    }

    onPageSizeChange(stime, start, etime, end, tagsDevice, page, pageSize) {

        let start_date = start + " " + stime;
        let end_date = end + " " + etime;
        const { user_id, user_name, token } = this.props;

        console.log(this.state.selectedDevice)
        console.log(this.state.selectedPOI)
        setLoader(true);
        fetch(`http://203.150.199.244/api/report/getReportPoiInOut/${1}/${10000000}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "deviceId": this.state.selectedDevice,
                "poiId": this.state.selectedPOI,
                "startDtm": start_date,
                "endDtm": end_date,
                "timeStopMinute": this.state.selectedTime
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    poiInOutList: data.RESULT_DATA,
                })
                setLoader(false);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
                setLoader(false);
            });

        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }

    getActiveDeviceUserRelated() {

        const { user_id, user_name, token } = this.props;
        fetch("http://203.150.199.244/api/admin/getActiveDeviceUserRelated/10000", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                // "filter":name
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    deviceList: data.RESULT_DATA
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    getPOIList() {

        const { currentPageSize } = this.state;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getPOIList/${1}/${1000000000}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                // "filter":name
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data.RESULT_DATA)
                this.setState({
                    poiList: data.RESULT_DATA,
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }


    render() {
        const { t, onClickBackToReportPortal } = this.props;
        const {
            isClickLoadReport,
            isDownLoadPdf,
            deviceList,
            poiList,
            poiInOutList,
            selectedDeviceName,
            isMobile
        } = this.state;

        // let dataLoop;
        // const dataList = map(deviceList, (dataEach, key) => {
        //     dataLoop = {
        //         value: dataEach.device_id,
        //         label: dataEach.device_no
        //     };
        //     return dataLoop;
        // });

        let newDeviceList = [{value:"",label:"-- ทั้งหมด --"}]
        deviceList.map((i) =>{
            newDeviceList.push({value: i.device_id,label: i.device_no})
        })
        // console.log(newDeviceList);

        // const poi = map(poiList, (dataEach, key) => {
        //     return ({
        //         value: dataEach.poi_id,
        //         label: dataEach.name
        //     });
        // });

        let newPoiList = [{value:"",label:"-- ทั้งหมด --"}]
        poiList.map((i) =>{
            newPoiList.push({value: i.poi_id,label: i.name})
        })
        // console.log(poiList);


        const stylePdf = isDownLoadPdf ? '800px' : '100%';
        console.log('poiInOutList', poiInOutList)
        return (
            <div className="gray-panel" >
                <div className="col-md-8">
                    <h5 style={{ paddingLeft: '2em', cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                        <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            style={{ color: 'rgb(115, 134, 213)' }} />
                        <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft: 10, marginRight: 5, cursor: "pointer" }} />{t('รายงานข้อมูล')}
                    </h5>
                </div>

                <hr />
                <h5>
                    <span className="fa-stack fa-lg" style={{ color: 'orange' }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{ color: 'white' }} />
                    </span>
                    {t('เข้า-ออก POI')}
                </h5>

                <form name="searchfrom" className="form-inline">
                    <div className="row">

                        <div className="form-group">

                            <label>{t('ทะเบียนรถ')}</label>&nbsp;
                            <div style={{ width: '140px', fontSize: '13px' }}>
                                <Select
                                    // value={selectedGroup}
                                    onChange={(data) => this.setState({ selectedDevice: data.value, selectedDeviceName: data.label })}
                                    options={newDeviceList}
                                    placeholder={`-- ${t('ทั้งหมด')} --`}
                                />
                            </div>&nbsp;
                            {isMobile && <div className="col-md-12">{'\n'}</div>}
                            <label >POI</label>&nbsp;
                            {isMobile && <div className="col-md-12">{'\n'}</div>}
                            <div style={{ width: '140px', fontSize: '13px' }}>
                                <Select
                                    // value={selectedGroup}
                                    onChange={(data) => this.setState({ selectedPOI: data.value })}
                                    options={newPoiList}
                                    placeholder={`-- ${t('ทั้งหมด')} --`}
                                />
                            </div>

                        </div>
                         &nbsp;
                            {isMobile && <div className="col-md-12">{'\n'}</div>} 
                            <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                            {isMobile && <div className="col-md-12">{'\n'}</div>}
                            <TimePicker className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />&nbsp;
                            <div className="row">
                                <div className="input-group date" id="datetimepicker1">
                                    <DateTimeRange
                                        small={true}
                                        isBack
                                        startDateId="MyDatePicker"
                                        endDateId="your_unique_end_date_id"
                                        onSelectDate={this.setRangeDate.bind(this)} />
                                    </div>
                            </div>
                            &nbsp;
                            
                            <TimePicker className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('23:50', 'HH:mm')} format={'HH:mm'} />
                            &nbsp;
                            
                            {isMobile && <div className="col-md-12">{'\n'}</div>}
                                <label>{t('เวลาจอด')}</label>&nbsp;
                                <select name="osp_delay" id="osp-delay-opt" className="form-control report-param" onChange={(e) => this.setState({ selectedTime: e.target.value })}>
                                    <option value={1}>1 {t('นาที')}</option>
                                    <option value={5}>5 {t('นาที')}</option>
                                    <option selected value={10}>10 {t('นาที')}</option>
                                    <option value={20}>20 {t('นาที')}</option>
                                </select>
                            &nbsp;&nbsp;
                            {isMobile && <div className="col-md-12">{'\n'}</div>}
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-report"
                                    onClick={(e) => this.btnSearchHistoryClick(e)}
                                    data-ext="html">
                                    {t('ตกลง')}
                                </button>
                                <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                    <span className="caret" />
                                </button>
                                <ul className={`dropdown-menu ${isClickLoadReport}`}>
                                    <li onClick={() => this.getReport()} className="item-text">
                                        <button className="btn btn-light">
                                            <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />
                                            &nbsp;&nbsp;&nbsp;{t('รายงานแบบ PDF')}
                                        </button>
                                    </li>

                                    <li onClick={() => this.setState({ isClickLoadReport: '', reportType: 'excel' })} className="item-text">
                                        <button className="btn btn-light">
                                            <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                            <ReactToExcel
                                                style={{ borderStyle: '' }}
                                                className="btn btn-light"
                                                table="table-to-excel"
                                                filename="area"
                                                sheet="sheet 1"
                                                buttonText={t('รายงานแบบ Excel')}
                                            />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            
                               
                    </div>
                </form>


                <hr />

                {
                    poiInOutList != null && poiInOutList != undefined && poiInOutList.length > 0 &&

                    <div id="printableTable" ref={el => (this.printableTable = el)}>
                        <table id='table-to-excel' border='1' style={{ fontSize: '14px', backgroundColor: 'white', width: stylePdf }} className="table table-bordered table-hover">
                            <div style={{ display: 'none', fontSize: '18px' }}><b>{t('เข้า-ออก พื้นที่')}</b><br /></div>
                            <div style={{ display: 'none', fontSize: '14px' }}><b>{`${t('ระหว่างวันที่')} ${this.getCurrentDate(startHistoryDate) + "," + this.state.selectHistoryDateRange.startTimeHistory} ${t('ถึง')} ${this.getCurrentDate(endHistoryDate) + "," + this.state.selectHistoryDateRange.endTimeHistory}`}</b><br /></div>
                            <thead style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                <tr style={{ height: '40px' }}>
                                    <th style={{ textAlign: 'center' }}>{t('วันที่')}</th>
                                    <th style={{ textAlign: 'center' }}>ทะเบียนรถ</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาเข้า')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาออก')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาที่อยู่ (นาที)')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('สถานที่')}</th>
                                    <th style={{ textAlign: 'center' }}>ที่อยู่</th>
                                    <th style={{ textAlign: 'center' }}>ละติจูด</th>
                                    <th style={{ textAlign: 'center' }}>ลองติจูด</th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: 'center' }}>

                                {
                                    poiInOutList.map((data, key) => {
                                        return (
                                            <tr key={key}
                                                onClick={() =>
                                                    this.setState({
                                                        lat: data.poi_latitude,
                                                        long: data.poi_longitude,
                                                        device_no: data.device_no,
                                                        symbolId: data.symbol_id,
                                                        symbolColor: data.symbol_color,
                                                        isClickRowToShowLocation: true,
                                                        placeName: data.place
                                                    })}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <td>{data.dtm_in}</td>
                                                <td>{data.device_no}</td>
                                                <td>{data.time_in}</td>
                                                <td>{data.time_out}</td>
                                                <td>{data.duration}</td>
                                                <td>{data.poi_name}</td>
                                                <td>{data.place}</td>
                                                <td>{data.poi_latitude}</td>
                                                <td>{data.poi_longitude}</td>
                                            </tr>
                                        )
                                    })
                                }


                            </tbody>
                        </table>
                        <br />
                        <div className="push-up text-center">
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button type="button" className="btn btn-light border border-secondary" onClick={() => this.getReport()}>
                                    <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />รายงานแบบ PDF
                        </button>
                                <button type="button" className="btn btn-light border border-secondary">
                                    <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                    <ReactToExcel
                                        style={{ borderStyle: '' }}
                                        className="btn btn-light"
                                        table="table-to-excel"
                                        filename="area"
                                        sheet="sheet 1"
                                        buttonText="รายงานแบบ Excel"
                                    />
                                </button>
                            </div>
                        </div>
                        {this.state.isClickRowToShowLocation &&
                            <div className="modal-confirm" style={{ display: 'block', position: 'fixed', top: '-70%' }} >
                                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: this.state.isFullScreen ? '100%' : '' }}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title custom_align" id="Heading">{this.state.placeName}</h4>
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-hidden="true"
                                                style={{ padding: '0px', margin: '0px', position: 'inherit' }}
                                                onClick={() => this.setState({ isClickRowToShowLocation: false })} >
                                                <span className="fa fa-times" aria-hidden="true" />
                                            </button>
                                        </div>
                                        <div className="modal-body" id="carAlertRow" >
                                            <MapAlertSummaryReport
                                                index={1}
                                                lat={this.state.lat}
                                                lng={this.state.long}
                                                text={this.state.device_no}
                                                symbolId={this.state.symbolId}
                                                symbolColor={this.state.symbolColor}
                                                handleFullScreenToggle={() => this.handleFullScreenToggle()}
                                                isFullScreen={this.state.isFullScreen}
                                            />
                                            <button className="btn btn-primary pull-right" onClick={() => this.setState({ isClickRowToShowLocation: false })}  >{t('ตกลง')}</button>
                                        </div>
                                    </div>
                                    {/* /.modal-content */}
                                </div>
                            </div>
                        }
                    </div>
                }

                {/* {
                    poiInOutList.length <= 0 &&

                    <div id="printableTable" ref={el => (this.printableTable = el)}>
                        <table id='table-to-excel' border='1' style={{ fontSize: '14px', backgroundColor: 'white', width: stylePdf }} className="table table-bordered table-hover">
                            <div style={{ display: 'none', fontSize: '18px' }}><b>{t('เข้า-ออก พื้นที่')}</b><br /></div>
                            <div style={{ display: 'none', fontSize: '14px' }}><b>{`${t('ระหว่างวันที่')} ${this.getCurrentDate(startHistoryDate) + "," + this.state.selectHistoryDateRange.startTimeHistory} ${t('ถึง')} ${this.getCurrentDate(endHistoryDate) + "," + this.state.selectHistoryDateRange.endTimeHistory}`}</b><br /></div>
                            <thead style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                <tr style={{ height: '40px' }}>
                                    <th style={{ textAlign: 'center' }}>{t('วันที่')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาเข้า')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาออก')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('เวลาที่อยู่ (นาที)')}</th>
                                    <th style={{ textAlign: 'center' }}>{t('สถานที่')}</th>
                                    <th style={{ textAlign: 'center' }}>ที่อยู่</th>
                                    <th style={{ textAlign: 'center' }}>ละติจูด</th>
                                    <th style={{ textAlign: 'center' }}>ลองติจูด</th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: 'center' }}>
                                <tr>
                                   <td colSpan={8}>-- ไม่มีข้อมูล --</td> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                } */}
            </div>
        );
    }
}

ReportPoiInOut.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickBackToReportPortal: PropTypes.func.isRequired
}

export default ReportPoiInOut;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportPoiInOut.js